export default "__VITE_ASSET__ac030110__"